/**
 * @generated SignedSource<<e7e92559163d52dfbc3d17c8e1e9d891>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JswExpandableProject$data = {
  readonly avatar: {
    readonly large: string;
  };
  readonly defaultNavigationItem?: {
    readonly url?: string | null;
  } | null;
  readonly id: string;
  readonly isFavourite: boolean | null;
  readonly name: string;
  readonly projectId: string;
  readonly projectKey: string;
  readonly projectStyle: JiraProjectStyle | null;
  readonly projectType: JiraProjectType | null;
  readonly webUrl: AGG$URL;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectActions">;
  readonly " $fragmentType": "JswExpandableProject";
};
export type JswExpandableProject$key = {
  readonly " $data"?: JswExpandableProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"JswExpandableProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "JswExpandableProject",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "large"
            },
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "webUrl"
      },
      "action": "THROW"
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "defaultNavigationItem",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "url"
                }
              ],
              "type": "JiraNavigationItem",
              "abstractKey": "__isJiraNavigationItem"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ProjectActions"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "2b8d7282fae2122fe5e52846af3731b6";

export default node;
